/* global HSCore */

import React, { useEffect, useContext, useRef } from "react";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import moment from "moment";
import _ from "lodash";
import { useCart } from "../../utils/Contexts/CartContext";

function CardTable({ columnSorts, setColumnSorts, domainData }) {
  const { t } = useContext(LanguageContext);
  const { addToCart, buttonLoading } = useCart();

  const setColumnSort = (columnIndex) => {
    const columnSortData = { ...columnSorts };
    if (!columnSortData[columnIndex]) columnSortData[columnIndex] = "asc";
    else if (columnSortData[columnIndex] === "asc")
      columnSortData[columnIndex] = "desc";
    else if (columnSortData[columnIndex] === "desc")
      columnSortData[columnIndex] = null;
    setColumnSorts(columnSortData);
  };

  const previousDomainDataRef = useRef(null);
  useEffect(() => {
    if (
      domainData?.length &&
      !_.isEqual(previousDomainDataRef.current, domainData)
    ) {
      previousDomainDataRef.current = domainData;
      document.querySelectorAll(".js-circle").forEach((item) => {
        HSCore.components.HSCircles.init(item);
      });
    }
  }, [domainData]);

  const moneyBackDaysMapping = {
    1: 5,
    2: 10,
    3: 15,
    4: 20,
    5: 25,
    6: 30,
    7: 40,
    8: 50,
    9: 60,
    10: 70,
    11: 80,
    12: 90,
  };

  return (
    <div className="table-responsive datatable-custom position-relative">
      <table
        id="datatable"
        className="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table"
      >
        <thead className="thead-light">
          <tr>
            <th className="table-column-pe-0"></th>
            <th
              className={`sorting${
                !columnSorts[1]
                  ? ""
                  : columnSorts[1] === "asc"
                  ? "_asc"
                  : "_desc"
              }`}
              onClick={() => setColumnSort(1)}
            >
              {t("Name")}
            </th>
            <th
              className={`sorting${
                !columnSorts[2]
                  ? ""
                  : columnSorts[2] === "asc"
                  ? "_asc"
                  : "_desc"
              }`}
              onClick={() => setColumnSort(2)}
            >
              {t("Money Back")}
            </th>
            <th
              className={`sorting${
                !columnSorts[3]
                  ? ""
                  : columnSorts[3] === "asc"
                  ? "_asc"
                  : "_desc"
              }`}
              onClick={() => setColumnSort(3)}
            >
              {t("Link Replacement")}
            </th>
            <th
              className={`sorting${
                !columnSorts[4]
                  ? ""
                  : columnSorts[4] === "asc"
                  ? "_asc"
                  : "_desc"
              }`}
              onClick={() => setColumnSort(4)}
            >
              {t("TAT")}
            </th>
            <th
              className={`sorting${
                !columnSorts[5]
                  ? ""
                  : columnSorts[5] === "asc"
                  ? "_asc"
                  : "_desc"
              }`}
              onClick={() => setColumnSort(5)}
            >
              {t("Links")}
            </th>
            <th
              className={`sorting${
                !columnSorts[6]
                  ? ""
                  : columnSorts[6] === "asc"
                  ? "_asc"
                  : "_desc"
              }`}
              onClick={() => setColumnSort(6)}
            >
              {t("Acceptance Rate")}
            </th>
            <th
              className={`sorting${
                !columnSorts[7]
                  ? ""
                  : columnSorts[7] === "asc"
                  ? "_asc"
                  : "_desc"
              }`}
              onClick={() => setColumnSort(7)}
            >
              {t("Links Alive")}
            </th>
            <th
              className={`sorting${
                !columnSorts[8]
                  ? ""
                  : columnSorts[8] === "asc"
                  ? "_asc"
                  : "_desc"
              }`}
              onClick={() => setColumnSort(8)}
            >
              {t("Price")}
            </th>
            <th></th>
          </tr>
        </thead>

        <tbody id="nav-one-eg1" aria-labelledby="nav-one-eg1-tab">
          {!!domainData?.length ? (
            domainData?.map((seller) =>
              seller?.seller?.offers?.map((offer) => (
                <tr key={seller?.seller?.uuid}>
                  <td className="table-column-pe-0">
                    <div
                      className="js-circle"
                      data-hs-circles-options={JSON.stringify({
                        value: seller?.seller?.rating || 0,
                        maxValue: 5,
                        duration: 300,
                        isViewportInit: true,
                        colors:
                          seller?.seller?.rating === null ||
                          seller?.seller?.rating > 4.4
                            ? ["rgba(0, 201, 167, 0.1)", "#00c9a7"]
                            : seller?.seller?.rating > 3
                            ? ["rgba(0, 201, 167, 0.1)", "#f5ca99"]
                            : seller?.seller?.rating > 1
                            ? ["rgba(0, 201, 167, 0.1)", "#ed4c78"]
                            : ["rgba(0, 201, 167, 0.1)", "#f4f5f6"],
                        radius: 20,
                        width: 4,
                        additionalText: "",
                        textFontSize: 13,
                        textClass: "circles-chart-content",
                        textColor:
                          seller?.seller?.rating === null ||
                          seller?.seller?.rating > 4.4
                            ? "#00c9a7"
                            : seller?.seller?.rating > 3
                            ? "#f5ca99"
                            : seller?.seller?.rating > 1
                            ? "#ed4c78"
                            : "#f4f5f6",
                      })}
                    />
                  </td>

                  {/* Seller Name and Last Active */}
                  <td className="table-column-ps-0">
                    <div className="ms-3">
                      <span className="d-block h5 text-inherit mb-0">
                        {seller?.seller?.name}{" "}
                        {(seller?.seller?.affiliation === 1 ||
                          seller?.seller?.affiliation === 2) && (
                          <i
                            className="bi-patch-check-fill text-primary"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Top endorsed"
                          ></i>
                        )}
                      </span>
                      <span className="d-block fs-5 text-body">
                        {(() => {
                          const lastActive = seller?.seller?.last_active;
                          if (!lastActive) {
                            return (
                              <>
                                <span className="legend-indicator bg-danger"></span>{" "}
                                {t("offline")}
                              </>
                            );
                          }

                          const lastActiveMoment = moment(lastActive);
                          const now = moment();
                          const diffInHours = now.diff(
                            lastActiveMoment,
                            "hours"
                          );
                          const diffInWeeks = now.diff(
                            lastActiveMoment,
                            "weeks"
                          );
                          const diffInMinutes = now.diff(
                            lastActiveMoment,
                            "minutes"
                          );

                          if (diffInMinutes <= 15) {
                            return (
                              <>
                                <span className="legend-indicator bg-success"></span>{" "}
                                {t("Online")}
                              </>
                            );
                          } else if (diffInHours < 1) {
                            return (
                              <>
                                Last active: {diffInMinutes} minute
                                {diffInMinutes > 1 ? "s" : ""} ago
                              </>
                            );
                          } else if (diffInHours < 24) {
                            return (
                              <>
                                {t("Last active")}: {diffInHours}{" "}
                                {diffInHours === 1 ? t("hour") : t("hours")}{" "}
                                {t("ago")}
                              </>
                            );
                          } else if (diffInWeeks < 1) {
                            const diffInDays = now.diff(
                              lastActiveMoment,
                              "days"
                            );
                            return (
                              <>
                                {t("Last active")}: {diffInDays}{" "}
                                {diffInDays === 1 ? t("day") : t("days")}{" "}
                                {t("ago")}
                              </>
                            );
                          } else {
                            return (
                              <>
                                {t("Last active")}: {diffInWeeks}
                                {diffInWeeks === 1
                                  ? t("week")
                                  : t("weeks")}{" "}
                                {t("ago")}
                              </>
                            );
                          }
                        })()}
                      </span>
                    </div>
                  </td>

                  {/* Money Back Policy */}
                  <td>
                    {seller?.seller?.terms?.money_back_policy ? (
                      (() => {
                        const days =
                          moneyBackDaysMapping[
                            seller.seller.terms.money_back_policy
                          ] || null; // Get days from mapping
                        if (days !== null) {
                          return (
                            <span
                              className={`badge ${
                                days > 0 && days < 30
                                  ? "bg-warning"
                                  : days === 30
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {`${days} ${t("days")}`}
                            </span>
                          );
                        } else {
                          return (
                            <span className="badge bg-danger">
                              {t("Not Provided")}
                            </span>
                          );
                        }
                      })()
                    ) : (
                      <span className="badge bg-danger">
                        {t("Not Provided")}
                      </span>
                    )}
                  </td>

                  <td>
                    {seller?.seller?.terms?.link_replacement_policy ? (
                      <span
                        className={`badge ${
                          seller?.seller?.terms?.link_replacement_policy === 12
                            ? "bg-success"
                            : "bg-warning"
                        }`}
                      >
                        {`${seller?.seller?.terms?.link_replacement_policy} ${
                          seller?.seller?.terms?.link_replacement_policy === 1
                            ? t("month")
                            : t("months")
                        }`}
                      </span>
                    ) : (
                      <span className="badge bg-danger">
                        {t("Not Provided")}
                      </span>
                    )}
                  </td>

                  {/* Offers (Assumed logic for showing time or badges based on offers) */}
                  <td>
                    {seller?.seller.terms?.tat > 0 ? (
                      <>
                        <span
                          className={`legend-indicator ${
                            seller?.seller?.terms?.tat / 86400 < 2
                              ? "bg-success"
                              : seller?.seller?.terms?.tat / 86400 >= 2 &&
                                seller?.seller?.terms?.tat / 86400 < 6
                              ? "bg-danger"
                              : "bg-primary"
                          }`}
                        ></span>
                        {Math.floor(seller?.seller?.terms?.tat / 86400)}d
                      </>
                    ) : (
                      <span className="badge bg-soft-secondary text-secondary">
                        {t("new")}
                      </span>
                    )}
                  </td>

                  <td>
                    <span>{offer?.links}</span>
                  </td>

                  <td>
                    <div className="d-flex align-items-center">
                      {seller?.seller?.terms?.acceptance_rate === null ||
                      seller?.seller?.terms?.acceptance_rate === 0 ? (
                        <span className="badge bg-soft-secondary text-secondary">
                          {t("new")}
                        </span>
                      ) : (
                        <>
                          <span style={{ width: "42px" }}>
                            {seller?.seller?.terms?.acceptance_rate}%
                          </span>
                          <div className="progress table-progress">
                            <div
                              className="progress-bar bg-success"
                              role="progressbar"
                              style={{
                                width: `${seller?.seller?.terms?.acceptance_rate}%`,
                              }}
                              aria-valuenow={
                                seller?.seller?.terms?.acceptance_rate
                              }
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                            <div
                              className="progress-bar bg-danger"
                              role="progressbar"
                              style={{
                                width: `${
                                  100 - seller?.seller?.terms?.acceptance_rate
                                }%`,
                              }}
                              aria-valuenow={
                                100 - seller?.seller?.terms?.acceptance_rate
                              }
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>

                          {/* <span style={{ width: "14px" }}></span> */}
                        </>
                      )}
                    </div>
                  </td>

                  <td>
                    <div className="d-flex align-items-center">
                      {seller?.seller?.terms?.links_alive === null ||
                      seller?.seller?.terms?.links_alive === 0 ? (
                        <span className="badge bg-soft-secondary text-secondary">
                          {t("new")}
                        </span>
                      ) : (
                        <>
                          <span style={{ width: "42px" }}>
                            {seller?.seller?.terms?.links_alive}%
                          </span>
                          <div className="progress table-progress">
                            <div
                              className="progress-bar bg-success"
                              role="progressbar"
                              style={{
                                width: `${seller?.seller?.terms?.links_alive}%`,
                              }}
                              aria-valuenow={seller?.seller?.terms?.links_alive}
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                            <div
                              className="progress-bar bg-danger"
                              role="progressbar"
                              style={{
                                width: `${
                                  100 - seller?.seller?.terms?.links_alive
                                }%`,
                              }}
                              aria-valuenow={
                                100 - seller?.seller?.terms?.links_alive
                              }
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                          <span style={{ width: "14px" }}></span>
                        </>
                      )}
                    </div>
                  </td>

                  {/* Price */}
                  <td>
                    <span>${offer?.price || 0}</span>
                  </td>
                  <td>
  <div>
    <button
      type="button"
      className="btn btn-white btn-sm"
      onClick={() => addToCart(offer?.uuid)}
      disabled={buttonLoading[offer?.uuid]} // Disable button when loading
      style={{ width: "120px" }}
    >
      {buttonLoading[offer?.uuid] ? (
        <span
          className="spinner-border spinner-border-sm text-secondary"
          role="status"
          aria-hidden="true"
          style={{ fontSize: "0.75rem" }}
        ></span>
      ) : (
        <>
          <i className="bi bi-cart-plus me-1"></i> {t("Add to Cart")}
        </>
      )}
    </button>
  </div>
</td>

                </tr>
              ))
            )
          ) : (
            <tr>
              <td colSpan="100%">
                <div
                  className="text-center p-4"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    textAlign: "center",
                  }}
                >
                  <img
                    className="mb-3"
                    src="https://static.articlesfactory.ai/app/svg/illustrations-light/oc-error.svg"
                    alt=""
                    style={{ width: "10rem" }}
                    data-hs-theme-appearance="dark"
                  />
                  <img
                    className="mb-3"
                    src="https://static.articlesfactory.ai/app/svg/illustrations/oc-error.svg"
                    alt=""
                    style={{ width: "10rem" }}
                    data-hs-theme-appearance="default"
                  />
                  <p className="mb-0">
                    {!domainData ? t("Loading data") : t("No data to show")}
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default CardTable;
